module.exports = __webpack_public_path__ + "assets/img/card1.9dfbcdc1.jpg";